import BigBuddyLogo from '../public/img/logos/big_buddy_01.png';
import BigGroupHugLogo from '../public/img/logos/big_group_hug_01.png';
import Image from 'next/image';
import Link from 'next/link';
import SaveAChildsHeartLogo from '../public/img/logos/save_a_childs_heart_01.png';

export default function PhilanthropicPartners(props)
{
    const { className } = props;

    return (
        <div className={ "grid grid-cols-1 sm:grid-cols-3 gap-40 items-center text-center" + ( className ? " " + className : "" ) }>
            <Link href="https://saveachildsheart.org/" className="block relative py-20 px-40 sm:px-20 border-2 rounded border-transparent hover:border-grey" title="Save A Child's Heart: Improving Pediatric Cardiac Care" target="__blank" passHref>
                <Image src={ SaveAChildsHeartLogo } alt="save_a_childs_heart_01" layout="responsive"/>
            </Link>
            <Link href="https://biggrouphug.org/" className="block relative py-20 px-40 sm:px-20 border-2 rounded border-transparent hover:border-grey" title="Big Group Hug | Community Support for Vulnerable Children" target="__blank" passHref>
                <Image src={ BigGroupHugLogo } alt="big_group_hug_01" layout="responsive"/>
            </Link>
            <Link href="https://www.bigbuddy.org.nz/" className="block relative py-20 px-40 sm:px-20 border-2 rounded border-transparent hover:border-grey" title="Big Buddy finds father figures for boys without dads" target="__blank" passHref>
                <Image src={ BigBuddyLogo } alt="big_buddy_01" layout="responsive"/>
            </Link>
        </div>
    );
}